import React, { useEffect, useState } from "react";
import CustomTable from "../organisms/CustomTable";
import { useDispatch, useSelector } from "react-redux";
import Button from "../atoms/Button";
import { Skeleton } from "antd";
import { ReactComponent as Filter } from "../svgs/filter.svg";
import SearchBar from "../atoms/SearchButton";
import FilterBox from "../molecules/FilterBoxPage";
import { retirementsTable } from "../../utils/API/requirementsTable";
import Pagination from "../atoms/Pagination";
import { useSearchParams } from "react-router-dom";
import ViewRetirementsDocuments from "../atoms/ViewRetirementsDocuments";
import moment from "moment";
import RemarksDailogBox from "../atoms/RemarksDailogBox";

const ActionButtons = ({
  documentHandler,
  disabled,
  remarks = "",
  remarksHandler,
}) => {
  const [docNotUploaded, setDocNotUploaded] = useState(false);
  const [remarksGiven, setRemarksGiven] = useState(false);

  useEffect(() => {
    if (!disabled) {
      // console.log(remarks);
      if (remarks !== "") {
        setRemarksGiven(true);
      } else {
        setDocNotUploaded(true);
      }
    }
  });

  return (
    <div className="flex gap-x-3">
      <div className="relative inline-block group">
        <button
          className={` px-6 h-7 rounded-md bg-opacity-25 text-center font-space-grotesk text-[9px] font-medium ${
            docNotUploaded
              ? "bg-gray-500  text-gray-500"
              : remarksGiven
              ? "bg-red-100 text-red-700"
              : "bg-blue-300 text-blue-800"
          } `}
          onClick={remarksGiven ? remarksHandler : documentHandler}
          disabled={docNotUploaded}
        >
          {remarksGiven ? "Remarks" : "Documents"}
        </button>
        {docNotUploaded && (
          <div className="absolute invisible bg-opacity-90 group-hover:visible w-48 h-12 bg-white left-[-45px] text-blue-800 rounded-md top-0 mt-[-40px] text-xs font-medium text-center pt-2">
            Seller has not uploaded Retirements Certificates yet
          </div>
        )}
      </div>
    </div>
  )
}

const RetirementsPage = () => {
  const dispatch = useDispatch()
  const { userType } = useSelector(state => state.authReducer)
  const [isDocumentOpen, setDocumentOpen] = useState(false)
  const [requirementsData, setRequirementsData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [searchItem, setSearchItem] = useState('')
  const [selectedRegistry, setSelectedRegistry] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [filterData, setFilterData] = useState(null)
  const currentPage = Number(searchParams.get('page')) || 1
  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });
  const [retirementsDocuments, setRequirementsDocuments] = useState(null);
  const [remarksData, setRemarksData] = useState("");
  const [remarksPopup, setRemarksPopup] = useState(false);

  const headerData = [
    'Project Name',
    'Project ID',
    'Category',
    'No. of credits',
    'Date of Retirements',
    'Registry',
    'Certificates'
  ]
  const pageSize = 10

  const transformData = (originalData) => {
    return originalData.paginatedData.map((item) => {
      const project = item.project;
      const retirementDate = moment(item.createdAt).format("DD-MM-YYYY");
      return [
        project.project_name,
        project.project_id,
        project.category.category_id.name,
        item.no_of_credits,
        retirementDate,
        project.registry_name.registryName,
        <ActionButtons
          documentHandler={() => handleViewClick(item.retirement_documents)}
          disabled={item.is_doc_uploaded}
          remarks={item.admin_remarks}
          remarksHandler={() => {
            handleRemarks(item.admin_remarks);
          }}
        />,
      ];
    });
  };

  const handleRemarks = (remarks) => {
    setRemarksData(remarks);
    setRemarksPopup(true);
  };

  const fetchRequirementsData = async () => {
    setIsLoading(true)
    try {
      const response = await retirementsTable(
        {
          filterData: filterData,
          page: currentPage,
          pageSize,
          searchQuery: searchItem
        },
        dispatch
      )
      const transformedData = transformData(response.data)
      setRequirementsData(transformedData)
      setPagination({
        totalItems: response.data.totalDocs,
        totalPages: response.data.totalPages
      })
    } catch (err) {
      setError('Something went wrong!')
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchRequirementsData()
  }, [filterData, currentPage, searchItem])

  const handleViewClick = rowdata => {
    setRequirementsDocuments(rowdata)
    setDocumentOpen(true)
  }
  const handleCertificateDialogCancel = () => {
    setDocumentOpen(false)
  }

  // const handleViewpopupClick = adminRemarks => {
  //   setPopupAdminRemarks(adminRemarks) 
  //   setIsViewPopupOpen(true)
  // }

  // const handlePopupCancel = () => {
  //   setIsViewPopupOpen(false)
  //   setPopupAdminRemarks('') 
  // }

  const handleSearch = () => {
    // console.log(searchItem)
  }

  const handleFilterButtonClick = () => {
    setFilterDialogOpen(true)
  }

  const handleFilterDialogClose = () => {
    setSelectedRegistry([])
    setSelectedCategory('')
    setFilterData(null)
    setFilterDialogOpen(false)
  }

  const handleCategoryChange = e => {
    const selectedValue = e.target.value
    setSelectedCategory(selectedValue)
    // console.log(selectedCategory)
  }

  const handleRegistryCheck = e => {
    {
      const selectedValue = e.target.value
      setSelectedRegistry(selectedValue)
    }
  }

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false)
    setFilterData({
      categoryId: selectedCategory,
      registries: selectedRegistry ? [selectedRegistry] : null
    })
  }
  return (
    <div className='bg-gray-100 h-full w-full p-6'>
      <h3 className='text-2xl font-bold mb-6'>Your Retirements</h3>
      <div className='w-full mt-8 h-[calc(90vh-2.4rem)] bg-white rounded-3xl shadow-formShadow flex flex-col'>
        <div className='flex justify-between pt-5 pb-12'>
          <div className='w-80 border-2 border-grey-800 rounded-lg mx-5 mb-5 '>
            <SearchBar
              onSearch={handleSearch}
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              variant='secondaryxl'
              className='text-black'
              borderColor='border-none'
              placeholderColor='black'
              inputBackground='white'
              svgStrokeColor='black'
              inputWidth='72'
              inputHeight='8'
            />
          </div>

          <div className="pr-7 ">
            <Button
              className="flex justify-center items-center gap-x-2 px-2 py-2 mb-3 "
              borderColor={"gray"}
              varient={"secondary"}
              onClick={handleFilterButtonClick}
            >
              {" "}
              <div className="flex gap-x-2 items-center">
                <Filter className="w-4 h-4" />
                <span>Filter</span>
              </div>
            </Button>
          </div>
        </div>

        <div className='flex-grow overflow-y-auto'>
          {isLoading ? (
            <>
              <CustomTable data={[]} headerData={headerData} />
              <div className='flex flex-col gap-y-4 p-4'>
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
                <Skeleton.Button block={true} active={true} />
              </div>
            </>
          ) : (
            <CustomTable data={requirementsData} headerData={headerData} />
          )}
        </div>
        {pagination.totalPages > 1 && (
          <div className='pb-4 px-3'>
            <Pagination
              current={currentPage}
              total={pagination.totalItems}
              pageSize={pageSize}
              setCurrentPage={page => setSearchParams({ page })}
            />
          </div>
        )}
      </div>

      <ViewRetirementsDocuments
        open={isDocumentOpen}
        retirementsDocuments={retirementsDocuments}
        onCancel={handleCertificateDialogCancel}
      />
      {/* <ViewPopUp
        open={isViewPopupOpen}
        onCancel={handlePopupCancel}
        admin_remarks={popupAdminRemarks} 
      /> */}
      {isFilterDialogOpen && (
        <FilterBox
          open={isFilterDialogOpen}
          onCancel={handleFilterDialogClose}
          onOk={handleFilterDialogSubmit}
          page='retirements'
          selectedRegistry={selectedRegistry}
          onCheckRegistry={handleRegistryCheck}
          selectedCategory={selectedCategory}
          onSelectCategory={handleCategoryChange}
        />
      )}

      {remarksPopup && (
        <RemarksDailogBox
          open={remarksPopup}
          remarks={remarksData}
          onCancel={() => setRemarksPopup(false)}
        />
      )}
    </div>
  )
}

export default RetirementsPage
